document.addEventListener('DOMContentLoaded', function() {
  const hotspots = document.querySelectorAll('.hotspot');
  const slider = document.getElementById('hotspot-fullscreen-slider');
  const closeBtn = document.querySelector('.hotspot-slider-close');
  let owlInitialized = false;

  function openSlider(index) {
    slider.style.display = 'flex';
    if (!owlInitialized) {
      $('.hotspot-slider-owl').owlCarousel({
        items: 1,
        loop: true,
        nav: true,
        dots: true,
        startPosition: index
      });
      owlInitialized = true;
    } else {
      $('.hotspot-slider-owl').trigger('to.owl.carousel', [index, 300]);
    }
    document.body.style.overflow = 'hidden';
  }

  hotspots.forEach((hotspot, i) => {
    hotspot.addEventListener('click', function() {
      openSlider(i);
    });
  });

  closeBtn.addEventListener('click', function() {
    slider.style.display = 'none';
    document.body.style.overflow = '';
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      slider.style.display = 'none';
      document.body.style.overflow = '';
    }
  });
});